import { yupResolver } from '@hookform/resolvers/yup';
import {
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { sentenceCase } from 'change-case';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import { useLoadingContext } from '../../context/loadingContext';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import { RHFSelect } from '../../components/hook-form/RHFSelect';
import RHFTextArea from '../../components/hook-form/RHFTextArea';
import Iconify from '../../components/Iconify';
import Label from '../../components/Label';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import StoreMoreMenu from '../../sections/@dashboard/store/StoreMoreMenu';
import { ProvinceService } from '../../Services/province.service';
import { StoreService } from '../../Services/store.service';

const EditStoreDialog = ({ item, onClose, onSubmit }) => {
  const [provinces, setProvinces] = useState([]);

  useEffect(() => {
    GetProvinces();
  }, []);

  const GetProvinces = async () => {
    const provincesData = await ProvinceService.GetProvinces();
    setProvinces(provincesData);
  };

  const CreateStoreSchema = Yup.object({
    name: Yup.string().required('Tên cửa hàng không được để trống'),
    phone: Yup.string().required('Số điện thoại không được để trống'),
    province: Yup.string().required('Vị trí không được để trống'),
    address: Yup.string().required('Địa chỉ không được để trống'),
    srcMap: Yup.string().required('Mã bản đồ không được để trống'),
  });

  const defaultValues = {
    name: item?.name,
    phone: item?.phone,
    province: item?.province._id,
    address: item?.address,
    srcMap: item?.srcMap,
  };

  const methods = useForm({
    resolver: yupResolver(CreateStoreSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleOnSubmit = (data) => {
    onSubmit(data);
  };

  return (
    <Dialog maxWidth="md" fullWidth={Boolean(true)} open={Boolean(true)}>
      <DialogTitle>Thêm cửa hàng</DialogTitle>
      <FormProvider methods={methods} onSubmit={handleSubmit(handleOnSubmit)}>
        <DialogContent>
          <Stack spacing={2}>
            <RHFTextField name="name" label={'Tên cửa hàng'} />
            <RHFTextField name="phone" label={'Số điện thoại cửa hàng'} />
            <RHFTextField name="address" label={'Địa chỉ'} />
            <RHFSelect name="province" label={'Vị trí'}>
              {provinces.map((province) => (
                <MenuItem key={province._id} value={province._id}>
                  {province.name}
                </MenuItem>
              ))}
            </RHFSelect>
            <RHFTextArea name="srcMap" label={'Source map'} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button type="button" color="error" variant="outlined" onClick={onClose}>
            Hủy
          </Button>
          <Button type="submit" variant="outlined">
            Lưu
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};

const CreateStoreDialog = ({ onClose, onSubmit }) => {
  const [provinces, setProvinces] = useState([]);

  useEffect(() => {
    GetProvinces();
  }, []);

  const GetProvinces = async () => {
    const provincesData = await ProvinceService.GetProvinces();
    setProvinces(provincesData);
  };

  const CreateStoreSchema = Yup.object({
    name: Yup.string().required('Tên cửa hàng không được để trống'),
    phone: Yup.string().required('Số điện thoại không được để trống'),
    province: Yup.string().required('Vị trí không được để trống'),
    address: Yup.string().required('Địa chỉ không được để trống'),
    srcMap: Yup.string().required('Mã bản đồ không được để trống'),
  });

  const methods = useForm({
    resolver: yupResolver(CreateStoreSchema),
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleOnSubmit = (data) => {
    onSubmit(data);
  };

  return (
    <Dialog maxWidth="md" fullWidth={Boolean(true)} open={Boolean(true)}>
      <DialogTitle>Thêm cửa hàng</DialogTitle>
      <FormProvider methods={methods} onSubmit={handleSubmit(handleOnSubmit)}>
        <DialogContent>
          <Stack spacing={2}>
            <RHFTextField name="name" label={'Tên cửa hàng'} />
            <RHFTextField name="phone" label={'Số điện thoại cửa hàng'} />
            <RHFTextField name="address" label={'Địa chỉ'} />
            <RHFSelect name="province" label={'Vị trí'}>
              {provinces.map((province) => (
                <MenuItem key={province._id} value={province._id}>
                  {province.name}
                </MenuItem>
              ))}
            </RHFSelect>
            <RHFTextArea name="srcMap" label={'Source map'} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button type="button" color="error" variant="outlined" onClick={onClose}>
            Hủy
          </Button>
          <Button type="submit" variant="outlined">
            Lưu
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};

const Store = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [stores, setStores] = useState([]);
  const [createMode, setCreateMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const { handleStartLoading, handleStopLoading } = useLoadingContext();

  useEffect(() => {
    getStores().finally(handleStopLoading);
  }, []);

  const getStores = async () => {
    handleStartLoading();
    const storesData = await StoreService.GetStores();
    setStores(storesData);
  };

  const handleCreateClick = () => {
    setCreateMode(true);
  };

  const handleCreateClose = () => {
    setCreateMode(false);
  };

  const handleEditClick = (item) => {
    setSelectedStore(item);
    setEditMode(true);
  };

  const handleEditClose = () => {
    setSelectedStore(null);
    setEditMode(false);
  };

  const handleDisable = (id) => {
    Swal.fire({
      customClass: {
        container: { zIndex: 999999 },
      },
      title: t('storeSure.title'),
      text: t('storeSure.disable'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('storeSure.yes'),
      cancelButtonText: t('storeSure.no'),
    }).then((result) => {
      if (result.isConfirmed) {
        handleStartLoading();
        StoreService.DisableStore(id)
          .then(() => {
            const newListStores = stores.map((store) => {
              if (store._id === id) return { ...store, status: 'Inactive' };
              return store;
            });

            setStores(newListStores);

            Swal.fire(t('storeSure.success'), '', 'success');
          })
          .catch((err) => Swal.fire('Error!', err.response.data, 'error'))
          .finally(handleStopLoading);
      }
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      customClass: {
        container: { zIndex: 999999 },
      },
      title: t('storeSure.title'),
      text: t('storeSure.delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('storeSure.yes'),
      cancelButtonText: t('storeSure.no'),
    }).then((result) => {
      if (result.isConfirmed) {
        handleStartLoading();
        StoreService.DeleteStore(id)
          .then(() => {
            const newList = stores.filter((store) => store._id !== id);
            setStores(newList);
            Swal.fire(t('storeSure.success'), '', 'success');
          })
          .catch((err) => Swal.fire('Error!', err.response.data, 'error'))
          .finally(handleStopLoading);
      }
    });
  };

  const handleEnable = (id) => {
    Swal.fire({
      customClass: {
        container: { zIndex: 999999 },
      },
      title: t('storeSure.title'),
      text: t('storeSure.enable'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('storeSure.yes'),
      cancelButtonText: t('storeSure.no'),
    }).then((result) => {
      if (result.isConfirmed) {
        handleStartLoading();
        StoreService.EnableStore(id)
          .then(() => {
            const newListStores = stores.map((store) => {
              if (store._id === id) return { ...store, status: 'Active' };
              return store;
            });

            setStores(newListStores);

            Swal.fire(t('storeSure.success'), '', 'success');
          })
          .catch((err) => Swal.fire('Error!', err.response.data, 'error'))
          .finally(handleStopLoading);
      }
    });
  };

  const handleCreateSubmit = (data) => {
    const temp = data.srcMap;
    let src = '';
    const element = document.createElement('div');
    element.innerHTML = temp;
    const iframe = element.getElementsByTagName('iframe')[0];

    if (!iframe) {
      src = temp;
    } else {
      src = iframe.src;
    }

    const newData = {
      ...data,
      srcMap: src,
    };
    handleStartLoading();
    StoreService.CreateStore(newData)
      .then((res) => {
        setStores((prevState) => [...prevState, res]);
        enqueueSnackbar('Thêm cửa hàng thành công', { variant: 'success' });
        handleCreateClose();
      })
      .catch((err) => {
        enqueueSnackbar(err.response.data, { variant: 'error' });
      })
      .finally(handleStopLoading);
  };

  const handleEditSubmit = (data) => {
    const temp = data.srcMap;
    let src = '';
    const element = document.createElement('div');
    element.innerHTML = temp;
    const iframe = element.getElementsByTagName('iframe')[0];
    if (!iframe) {
      src = temp;
    } else {
      src = iframe.src;
    }
    const newData = {
      ...data,
      srcMap: src,
    };
    StoreService.EditStore(newData, selectedStore._id)
      .then((res) => {
        const newList = stores.map((store) => {
          if (store._id === selectedStore._id) return res;
          return store;
        });
        setStores(newList);
        enqueueSnackbar('Cập nhật cửa hàng thành công', { variant: 'success' });
        handleEditClose();
      })
      .catch((err) => {
        enqueueSnackbar(err.response.data, { variant: 'error' });
      });
  };

  return (
    <Page title="Store">
      {createMode && <CreateStoreDialog onClose={handleCreateClose} onSubmit={handleCreateSubmit} />}
      {editMode && <EditStoreDialog item={selectedStore} onClose={handleEditClose} onSubmit={handleEditSubmit} />}
      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Danh sách cửa hàng
          </Typography>
          <Button onClick={handleCreateClick} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            Thêm cửa hàng
          </Button>
        </Stack>
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell width={'60px'}>STT</TableCell>
                    <TableCell>Tên nhà hàng</TableCell>
                    <TableCell>Số điện thoại</TableCell>
                    <TableCell>Vị trí</TableCell>
                    <TableCell>Địa chỉ</TableCell>
                    <TableCell>Trạng thái</TableCell>
                    <TableCell> </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stores.map((store, index) => (
                    <TableRow hover key={store._id} tabIndex={-1}>
                      <TableCell width={60} align="center">
                        {index + 1}
                      </TableCell>
                      <TableCell>{store.name}</TableCell>
                      <TableCell>{store.phone}</TableCell>
                      <TableCell>{store.province.name}</TableCell>
                      <TableCell>{store.address}</TableCell>
                      <TableCell align="left">
                        <Label variant="ghost" color={(store.status === 'Inactive' && 'error') || 'success'}>
                          {sentenceCase(store.status)}
                        </Label>
                      </TableCell>
                      <TableCell>
                        <StoreMoreMenu
                          onDisable={handleDisable}
                          onEnable={handleEnable}
                          onDelete={handleDelete}
                          onEdit={handleEditClick}
                          id={store._id}
                          item={store}
                          status={store.status}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>
      </Container>
    </Page>
  );
};

export default Store;
